import { defa }              from 'defa-object';
import Controller            from 'scripts/poppet/controller';

/**
 * defa.controllers.TermsAndConditionsController
 * The controller for the TermsAndConditionsRouter
 * @version 1.0.0
 */
const channelLayout = Bb.Radio.channel( 'layout' );

const TermsAndConditionsController = Controller.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------
	
	/**
	 * Landing route for: terms-and-conditions(/)
	 * @void
	 */
	showTermsAndConditions: function () {
		$( '[data-click="open-terms-and-conditions"]' ).trigger( 'show:terms' );
	},
	
	showTerms: function (terms, isAccepted) {
		let myTerms = new defa.views.TermsAndConditionsView( {
			isAccepted: isAccepted,
			terms     : terms,
		} );
		channelLayout.request( 'root' ).showChildView( 'main', myTerms );
		channelLayout.trigger( 'menu:hide' );
	},

} );

export default TermsAndConditionsController;